import {
    Modal,
    ModalSizes,
    StringHelpers,
    useDisabledContext,
    useLangContext,
} from 'carrier-fe';
import { useState } from 'react';
import CustomerCompanyForm from '../pages/customer/form';

interface CreateCustomerModalProps {
    open: boolean;
    onClose: () => void;
    onCustomerCreated: (customer: { id: string; name: string }) => void;
    installerCompanyId: string;
}

function CreateCustomerModal({
    open,
    onClose,
    onCustomerCreated,
    installerCompanyId,
}: CreateCustomerModalProps) {
    const { crud } = useLangContext();
    const { disabled } = useDisabledContext();
    const [submitButton, setSubmitButton] = useState<JSX.Element | null>(null);

    const handleSuccess = (customer: { id: string; name: string }) => {
        onCustomerCreated(customer);
        onClose();
    };

    if (!open) return null;

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={StringHelpers.title(
                StringHelpers.replaceFirst(
                    crud?.pages?.create?.title || 'Create :model',
                    ':model',
                    crud?.models?.customer || 'Customer'
                )
            )}
            disabled={disabled}
            size={ModalSizes.ExtraLarge}
            closeText={crud?.buttons?.cancel?.default || 'Cancel'}
            overriddenConfirmButton={submitButton || undefined}
        >
            <CustomerCompanyForm
                asModal
                installerCompanyId={installerCompanyId}
                onSuccess={handleSuccess}
                onReady={setSubmitButton}
            />
        </Modal>
    );
}

export default CreateCustomerModal;
